import { Component, computed, Inject, inject, output, signal, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ModalResponseCodes, ModalService } from '@src/suite/common/components/modal/modal.service';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { ProductionCommandBase } from '@src/suite/common/store/story/models/story.models';
import { ProductionCommandsTitle, ProductionCommandType } from '@src/suite/common/utils/ml-2-html-utils';
import { catchError, take } from 'rxjs';

@Component({
    selector: 'st-production-command-dialog',
    templateUrl: './production-command-dialog.html',
    styleUrls: ['./production-command-dialog.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-production-command-dialog' },
})
export class ProductionCommandDialogComponent {
    private store = inject(Store);
    private modalService = inject(ModalService);
    private dialogRef = inject(MatDialogRef<ProductionCommandDialogComponent>);

    public ProductionCommandType = ProductionCommandType;
    public ProductionCommandsTitle = ProductionCommandsTitle;
    public languageSettings = this.store.selectSignal(selectI18N);
    public command = signal<ProductionCommandBase>(null);
    public editMode = signal<boolean>(false);

    commandType = computed(() => this.command()?.commandType?.toUpperCase());

    onInsert = output<ProductionCommandBase>();
    onUpdate = output<ProductionCommandBase>();
    onDelete = output<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            command: ProductionCommandBase;
            editMode: boolean;
        }
    ) {
        this.command.set(this.data.command);
        this.editMode.set(!!this.data.editMode);
    }

    public cancel() {
        this.dialogRef.close();
    }

    public updateCommand() {
        this.onUpdate.emit(this.command());
        this.dialogRef.close();
    }

    public insertCommand() {
        this.onInsert.emit(this.command());
        this.dialogRef.close();
    }

    async deleteCommand() {
        const modalRef = this.modalService.openModal(`${this.languageSettings().PSTWebConfirmDeletePart1} item?`, '', ModalResponseCodes.OK, ModalResponseCodes.CANCEL);
        modalRef.result
            .pipe(
                take(1),
                catchError(() => {
                    return [ModalResponseCodes.CANCEL];
                })
            )
            .subscribe(res => {
                if (res === ModalResponseCodes.CANCEL) {
                    this.dialogRef.close();
                } else {
                    this.onDelete.emit();
                    this.dialogRef.close();
                }
            });
    }

    commandChanged(command: ProductionCommandBase) {
        this.command.set(command);
    }
}
